define('cartware/components/FeatureFlags',[
	"./Utilities"
], function(
	Utils
) {

	function FeatureFlags(flags) {
		this.flags = flags;
	}

	FeatureFlags.prototype = {
		flags: null,

		isEnabled: function(flag) {
			return !!Utils.getPath(this.flags, flag)
		},

		getFlags: function() {
			return this.flags;
		}
	}

	return FeatureFlags;
});
